/** Plain-text reply to Thijs, for the "Kopieer als e-mail" button.
 *  Kept next to the page so both stay in sync. */
export const MAIL_TEXT = `Dag Thijs,

Bedankt, dit is duidelijk en we gaan met alles akkoord. Hieronder puntsgewijs, en onderaan de drie documenten die je vroeg.

1. GEEN SSH
Akkoord. We hebben geen permanente servertoegang nodig. Een tijdsgebonden gastaccount met MFA volstaat voor de eenmalige migratie en voor incidenten. Namen en e-mailadressen stuur ik apart door.

2. GITHUB EN GITHUB ACTIONS
Akkoord, en het is een verbetering ten opzichte van vandaag. Nu draait er een eigen Git-server (Gitea) en wordt er vanaf een werkstation gedeployed. In jullie model verdwijnt Gitea volledig.
Wij leveren de Dockerfiles, de compose-bestanden en de workflows mee in de repository. De secrets gaan naar GitHub Actions secrets, er blijft geen .env op de server staan.
Vraag: GitHub Container Registry of Azure Container Registry?

3. SERVER EN DATAGROEI
4 vCPU, 8 GB RAM en 80 GB SSD is ruim voldoende.
De database is vandaag 28 MB en de volledige omgeving 225 MB. Er komt ongeveer 5 a 10 MB per maand bij: enkel dagelijkse rapportagecijfers, geen media en geen klantdata. 80 GB volstaat jarenlang.

4. DOMEINNAAM
Vandaag draait alles op pulse.sidestream.be, met git.pulse.sidestream.be voor de Git-server (die vervalt).
Voorstel: pulse.prado.com. Belangrijk: bij een nieuwe hostname moet elke platformkoppeling opnieuw geregistreerd en geautoriseerd worden. Dat is het meeste werk in deze migratie.

5. DNS EN CERTIFICAAT
Een A-record volstaat: pulse.prado.com naar het IP van de server, TTL 300 tijdens de migratie.
Omdat er een WAF voor komt, kiezen we DNS-01 in plaats van HTTP-01. HTTP-01 vereist dat Let's Encrypt rechtstreeks een bestand op poort 80 kan ophalen, en dat blokkeert een WAF meestal. Daarvoor hebben we een API-token nodig om een TXT-record te zetten. Termineren jullie TLS liever op de WAF, dan hebben wij niets nodig.

6. FIREWALL
Inkomend 80 en 443 volstaat, poort 22 mag dicht. Alle uitgaand verkeer is HTTPS. De volledige lijst endpoints staat in het architectuurdocument, zodat je de uitgaande regels gericht kan beperken.

7. PLATFORM-APPS
Terecht punt en vandaag niet volledig in orde. De volledige inventaris zit in het overdrachtsdocument, met per platform de eigenaar en de bewaarplaats van de secrets.
Kort: Meta, Microsoft/Bing, TikTok, Klaviyo en Teamtailor staan al op Prado-accounts. Google Ads/GA4, Reddit, LinkedIn en Resend hangen vandaag aan een persoonlijk account en moeten naar een Prado-account. Pinterest wacht nog op Standard access; zolang komen die cijfers via Converge binnen.

8. RESEND
Resend verstuurt enkel de transactionele mails van de influencer-app (voorstellen, contracten, uitnodigingen) vanaf marketing.prado.com. Het is bewust een API-koppeling en geen marketingplatform, net omdat die mails vanuit de applicatie vertrekken.
De koppeling hangt vandaag aan een persoonlijk account en moet hoe dan ook naar een Prado-account. Willen jullie in plaats daarvan een bestaand platform gebruiken, dan kan dat ook: het verzenden zit achter een enkele functie. Laat weten welk platform en of het SMTP of API wordt.

9. BACK-UP
Azure Backup op de VM plus een dagelijkse database-dump naar blob storage is precies wat we nodig hebben. Een dump is enkele tientallen MB.

10. ONDERHOUDSVENSTER EN KRITIKALITEIT
Voorstel: een weekavond vanaf 19u, of zaterdagvoormiddag. Twee uur volstaat.
En om je vraag te beantwoorden: dit is niet productiekritisch. Het is een interne rapportageomgeving zonder klantverkeer, de cijfers worden een keer per nacht opgehaald. Een storing betekent verouderde rapportage, geen omzetverlies en geen dataverlies.

DE DRIE DOCUMENTEN
- Architectuur: de containers, de volumes, de interne poorten en de uitgaande endpoints.
- Migratie-runbook: de stappen in jullie model, de verwachte downtime en de terugvalprocedure.
- Overdrachtsdocumentatie: hoe de omgeving herstart en hersteld wordt, en de inventaris van alle koppelingen.

Ze staan gebundeld op de overdrachtspagina van het dashboard, zodat jullie steeds de actuele versie hebben.

WAT WE NOG NODIG HEBBEN
- Gastaccounts voor de personen die ik doorstuur
- De GitHub-organisatie en de keuze van registry
- Bevestiging van de hostname
- Een API-token voor DNS-01, of TLS op de WAF
- Bevestiging van het e-mailplatform
- Twee mogelijke onderhoudsmomenten

Een call om dit te overlopen is prima, dit bericht kan dan als agenda dienen.

Met vriendelijke groeten,
Achile`;
